import { motion } from "framer-motion";
import { GALLERY } from "@/data/site";

const SPANS = [
  "sm:col-span-2 sm:row-span-2",
  "",
  "",
  "",
  "sm:col-span-2",
  "",
];

export const Gallery = () => {
  return (
    <section id="gallery" data-testid="gallery-section" className="relative py-24 md:py-32 bg-[#050505]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="mb-14">
          <span className="text-xs tracking-[0.3em] uppercase text-gold font-bold font-mono-x">The Work</span>
          <h2 className="font-heading font-bold uppercase tracking-tight text-4xl sm:text-5xl mt-4 text-white">
            Recent <span className="gold-gradient-text">Builds</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 auto-rows-[180px] sm:auto-rows-[200px] gap-4">
          {GALLERY.map((g, i) => (
            <motion.div
              key={g.src}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.06 }}
              className={`group relative overflow-hidden border border-white/10 ${SPANS[i] || ""}`}
            >
              <img
                src={g.src}
                alt={g.alt}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="absolute bottom-0 left-0 p-4 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                <span className="text-xs uppercase tracking-widest text-gold font-mono-x">{g.alt}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
